.mainSticky {
	padding-top: 10em;
}

.mainSurvey {
	width: 50%;
	position: absolute;
	bottom: 0;
	display: flex;
	justify-content: center;
	right: 25%;

	.formSurvey {
		width: 100%;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		background-color: #f1f5f9;

		--tw-shadow-up: 0px 0px 2px rgba(40, 41, 61, 0.12), 0px -1.5px 3px rgba(96, 97, 112, 0.2);
		--tw-shadow-colored-up: 0px 0px 2px var(--tw-shadow-color), 0px -1.5px 3px var(--tw-shadow-color);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow-up);

		.titlesSurvey {
			padding: 7px 15px 0px 15px;

			.first {
				font-size: 13px;
				font-weight: 600;
			}

			.second {
				font-size: 14px;
			}
		}

		.numbersSurvey {
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 1em;
			color: #f1f5f9;
			font-weight: 400;
			font-size: 20px;

			.numberSurvey {
				padding: 1px 12px;
				cursor: pointer;

				&.selected {
					border: 2px solid #212529;
				}
			}
		}

		.buttonsSurvey {
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 1em;

			.buttonSurvey {
				padding: 0.5em 1em;
				border-radius: 5px;
				background-color: #7fb02f;
				color: #f1f5f9;
				font-size: 14px;
				cursor: pointer;
				margin: 0px 5px;

				&.no_answer {
					font-size: 13px;
					background-color: #f1f5f9;
					color: #a3a3a3;
					border: 1px solid #a3a3a3;
				}
			}
		}

		.questionsSurvey {
			padding: 0px 15px;
			background-color: #f1f5f9;

			.questionSurvey {
				padding: 5px 1em;
				border-bottom: 1px solid #d3d3d3;

				.question {
					font-size: 14px;
					font-weight: 600;
				}
			}

			.textareaAnswer {
				width: 100%;
				height: 100px;
				border-radius: 5px;
				border: 1px solid #d3d3d3;
				padding: 0.5em;
				margin: 0.5em 0px;
				font-size: 14px;
			}
		}
	}
}
